












































import { Component, Vue } from "vue-property-decorator";
import ErrorBox from "../components/ErrorBox.vue";
import { namespace } from "vuex-class";
import { signIn } from "../api/auth";

const auth = namespace("auth");

@Component({
  components: {
    ErrorBox,
  },
})
export default class Login extends Vue {
  @auth.Getter("getCodeChallenge")
  codeChallenge!: string | null;

  @auth.Getter("isLoading")
  isLoading!: boolean;

  @auth.Getter("getLoginError")
  loginError!: string | null;

  @auth.Action("initializeStore")
  initializeStore!: () => Promise<any>;

  requestLogin(): void {
    this.initializeStore().then(() => {
      if (this.codeChallenge !== null) {
        signIn(this.codeChallenge);
      }
    });
  }
}
